import DashboardOverview from '../components/DashboardOverview';
import DashboardUserMenu from '../components/DashboardUserMenu';
import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Container, Button, Form, Table, Card, Offcanvas, Row, Col, Modal, Accordion, Dropdown, ProgressBar, InputGroup, ListGroup
} from 'react-bootstrap';
import {
  BiChalkboard, BiBarChartAlt, BiLogOut, BiHomeAlt, BiCheckSquare
} from 'react-icons/bi';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { toast } from 'react-toastify';
import './TeacherDashboard.css';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { API_URL } from '../config';
import { formatDateOnly, getDateOnlyKey, getLocalDateInputValue } from '../utils/dateDisplay';
import quranChapters from '../data/quranChapters';
import StudentAttendancePanel from '../components/StudentAttendancePanel';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const TeacherDashboard = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('dashboard'); // 'dashboard' | 'classView' | 'classAttendance' | 'report'
  const sessionExpiredRef = useRef(false);

  const [classes, setClasses] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState(null);

const [attendance, setAttendance] = useState({});
const [lateAttendance, setLateAttendance] = useState({});
const [comments, setComments] = useState({});
const [attendanceDate, setAttendanceDate] = useState(() => getLocalDateInputValue());

  const [report, setReport] = useState([]);
  const [reportFilters, setReportFilters] = useState({ class_id: '', student_id: '', start_date: '', end_date: '' });
  const [showReportModal, setShowReportModal] = useState(false);

  // ------- Attendance insights state -------
  const [reportInsights, setReportInsights] = useState({
  totalMeetings: 0,
  byStudent: {},      // { key: { name, present, absent, excused, total, pct } }
  ranked: [],
  bestStudent: null,
  worstStudent: null,
  bestStudents: [],
  worstStudents: [],
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const emptyStudentForm = { first_name: '', last_name: '' };
  const [showTeacherStudentModal, setShowTeacherStudentModal] = useState(false);
  const [teacherStudentForm, setTeacherStudentForm] = useState(emptyStudentForm);
  const [editingTeacherStudent, setEditingTeacherStudent] = useState(null);
  const [openTeacherStudentDropdownId, setOpenTeacherStudentDropdownId] = useState(null);
  const [studentToRemove, setStudentToRemove] = useState(null);
  const [attendanceProfileStudent, setAttendanceProfileStudent] = useState(null);
  

  // Notes modal + selection
  const [showNotes, setShowNotes] = useState(false);
  const [notesStudent, setNotesStudent] = useState(null);

  // Notes list + loading
  const [notes, setNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);

  // Notes add/edit
  const [newNoteText, setNewNoteText] = useState('');
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [editingNoteText, setEditingNoteText] = useState('');
  const [noteToDelete, setNoteToDelete] = useState(null);

  // ----- GOALS modal + selection -----
const [showGoals, setShowGoals] = useState(false);
const [goalsStudent, setGoalsStudent] = useState(null);

// list + loading
const [goals, setGoals] = useState([]);
const [goalsLoading, setGoalsLoading] = useState(false);

// add form
const [newGoalText, setNewGoalText] = useState('');
const [newGoalTerm, setNewGoalTerm] = useState(''); // e.g. "2024-25" or "Semester 1"

// edit form
const [editingGoalId, setEditingGoalId] = useState(null);
const [editingGoalText, setEditingGoalText] = useState('');
const [editingGoalTerm, setEditingGoalTerm] = useState('');

// delete confirm
const [goalToDelete, setGoalToDelete] = useState(null);
// ----- GOALS modal extra form fields -----
const [newGoalStatus, setNewGoalStatus] = useState('in-progress');
const [newGoalDueDate, setNewGoalDueDate] = useState('');

const [editingGoalStatus, setEditingGoalStatus] = useState('');
const [editingGoalDueDate, setEditingGoalDueDate] = useState('');

// Quran assignments
const emptyQuranAssignment = {
  surah_number: '',
  start_verse: '1',
  end_verse: '1',
  due_date: '',
  instructions: '',
};
const [showQuranAssignments, setShowQuranAssignments] = useState(false);
const [quranStudent, setQuranStudent] = useState(null);
const [quranAssignments, setQuranAssignments] = useState([]);
const [quranAssignmentsLoading, setQuranAssignmentsLoading] = useState(false);
const [quranAssignmentSaving, setQuranAssignmentSaving] = useState(false);
const [quranAssignmentForm, setQuranAssignmentForm] = useState(emptyQuranAssignment);

// To-do list (teacher)
const [todos, setTodos] = useState([]);
const [todoText, setTodoText] = useState('');

// Dashboard summary
const [dashboardSummary, setDashboardSummary] = useState({
  totals: { totalClasses: 0, totalStudents: 0 },
  attendanceLast30: {
    presentCount: 0,
    absentCount: 0,
    excusedCount: 0,
    lateCount: 0,
    totalMarked: 0,
    presentPct: 0,
  },
  recentNotes: [],
  attendanceByClass: [],
  needsAttention: {
    studentsWithRepeatedAbsences: [],
    overdueQuranAssignments: [],
  },
});
const [dashboardLoading, setDashboardLoading] = useState(true);
const [selectedAttendanceChartDays, setSelectedAttendanceChartDays] = useState({});




  const authHeader = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const handleSessionExpired = () => {
    if (sessionExpiredRef.current) return;
    sessionExpiredRef.current = true;
    toast.error('Your session expired. Please log in again.');
    logout();
    navigate('/login');
  };

  const handleApiError = (err, fallbackMsg) => {
    const status = err?.response?.status;
    if (status === 401 || status === 403) {
      handleSessionExpired();
      return;
    }
    if (status >= 500) {
      toast.error('Server issue. Please try again later.');
      return;
    }
    if (fallbackMsg) toast.error(fallbackMsg);
  };

// ----- To-dos (teacher) -----
const fetchTodos = async () => {
  try {
    const { data } = await axios.get(`${API_URL}/teachers/todos`, authHeader());
    setTodos(Array.isArray(data) ? data : []);
  } catch (err) {
    console.error('Failed to load todos', err);
    handleApiError(err, 'Could not load to-do list');
  }
};

const addTodo = async (text) => {
  if (!text?.trim()) return;
  try {
    const { data } = await axios.post(
      `${API_URL}/teachers/todos`,
      { text: text.trim() },
      authHeader()
    );
    setTodos((prev) => [data, ...prev]);
  } catch (err) {
    console.error('Failed to add todo', err);
    handleApiError(err, 'Could not add task');
  }
};

const toggleTodo = async (todo) => {
  try {
    const { data } = await axios.put(
      `${API_URL}/teachers/todos/${todo.id}`,
      { done: !todo.done },
      authHeader()
    );
    setTodos((prev) => prev.map((t) => (t.id === todo.id ? data : t)));
  } catch (err) {
    console.error('Failed to update todo', err);
    handleApiError(err, 'Could not update task');
  }
};

const deleteTodo = async (todoId) => {
  try {
    await axios.delete(`${API_URL}/teachers/todos/${todoId}`, authHeader());
    setTodos((prev) => prev.filter((t) => t.id !== todoId));
  } catch (err) {
    console.error('Failed to delete todo', err);
    handleApiError(err, 'Could not delete task');
  }
};

// ---------- Helpers to open views (single source of truth) ----------
const openClassView = (id) => {
  setSelectedClassId(id);
  setActiveTab('classView');
};

  const openAttendanceView = (id) => {
    setSelectedClassId(id);
    setActiveTab('classAttendance');
  };

  const handleSidebarNav = (tabName) => {
    setActiveTab(tabName);
    if (window.innerWidth < 992) setSidebarOpen(false);
  };

  // ---------- Lifecycle ----------
  useEffect(() => {
    if (!currentUser || currentUser.role !== 'teacher') {
      navigate('/');
    } else {
      setActiveTab('dashboard');
      loadClasses();
      loadDashboardSummary();
      fetchTodos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (activeTab !== 'dashboard' || currentUser?.role !== 'teacher') return undefined;

    const refreshDashboardSummary = () => {
      if (!document.hidden) {
        loadDashboardSummary();
      }
    };

    refreshDashboardSummary();
    const intervalId = window.setInterval(refreshDashboardSummary, 30000);
    window.addEventListener('focus', refreshDashboardSummary);
    document.addEventListener('visibilitychange', refreshDashboardSummary);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener('focus', refreshDashboardSummary);
      document.removeEventListener('visibilitychange', refreshDashboardSummary);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, currentUser?.role]);

  // when date or class changes in attendance view, load existing marks
  useEffect(() => {
    if (activeTab === 'classAttendance' && selectedClassId) {
      loadAttendanceForDate(selectedClassId, attendanceDate);
    }
  }, [activeTab, selectedClassId, attendanceDate]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Build per-student metrics from the raw report rows your API returns
function computeAttendanceInsights(rows) {
  const byStudent = {};
  const dateSet = new Set();

  for (const r of rows) {
    const name = `${r.first_name ?? ''} ${r.last_name ?? ''}`.trim() || 'Unknown';
    const key = r.student_id ?? name;
    const status = String(r.status || '').toLowerCase().trim();

    if (r.date) dateSet.add(getDateOnlyKey(r.date));
    if (!byStudent[key]) {
      byStudent[key] = { key, name, present: 0, late: 0, absent: 0, excused: 0, total: 0, pct: 0 };
    }

    if (status === 'present' || status === 'absent' || status === 'excused') {
      if (status === 'present') {
        byStudent[key].present += 1;
        if (Number(r.is_late) === 1 || r.is_late === true) byStudent[key].late += 1;
      }
      if (status === 'absent')  byStudent[key].absent  += 1;
      if (status === 'excused') byStudent[key].excused += 1;
      byStudent[key].total += 1;
    }
  }

  for (const s of Object.values(byStudent)) {
    const countedTotal = s.present + s.absent;
    s.pct = countedTotal > 0 ? Math.round((s.present / countedTotal) * 100) : 0;
  }

  const ranked = Object.values(byStudent)
    .sort((a, b) => (b.pct - a.pct) || (a.absent - b.absent) || (b.total - a.total));

  const bestStudent = ranked[0] || null;
  const worstStudent = [...ranked]
    .sort((a, b) => (b.absent - a.absent) || (a.pct - b.pct) || (b.total - a.total))[0] || null;
  const bestStudents = bestStudent ? ranked.filter((s) => s.pct === bestStudent.pct) : [];
  const actualWorstStudent = worstStudent?.absent > 0 ? worstStudent : null;
  const worstStudents = actualWorstStudent ? ranked.filter((s) => s.absent === actualWorstStudent.absent) : [];

  return {
    totalMeetings: dateSet.size,
    byStudent,
    ranked,
    bestStudent,
    worstStudent: actualWorstStudent,
    bestStudents,
    worstStudents,
  };
}



const loadDashboardSummary = async () => {
  try {
    setDashboardLoading(true);
    const res = await axios.get(
      `${API_URL}/teachers/dashboard-summary`,
      authHeader()
    );
    setDashboardSummary(res.data || {});
  } catch (err) {
    console.error(err);
    handleApiError(err, 'Failed to load dashboard summary');
  } finally {
    setDashboardLoading(false);
  }
};
  // ---------- Data ----------
  const loadClasses = async () => {
    try {
      const response = await axios.get(`${API_URL}/classes/my-classes`, authHeader());
      setClasses(response.data || []);
    } catch (err) {
      console.error(err);
      handleApiError(err, 'Failed to fetch your classes');
    }
  };

  const openAddTeacherStudent = () => {
    setEditingTeacherStudent(null);
    setTeacherStudentForm(emptyStudentForm);
    setShowTeacherStudentModal(true);
  };

  const openEditTeacherStudent = (student) => {
    setOpenTeacherStudentDropdownId(null);
    setEditingTeacherStudent(student);
    setTeacherStudentForm({
      first_name: student.first_name || '',
      last_name: student.last_name || '',
    });
    setShowTeacherStudentModal(true);
  };

  const openRemoveTeacherStudent = (student) => {
    setOpenTeacherStudentDropdownId(null);
    setStudentToRemove(student);
  };

  const openStudentAttendanceProfile = (student) => {
    setOpenTeacherStudentDropdownId(null);
    const selectedClass = classes.find((cls) => String(cls.id) === String(student.class_id || selectedClassId));
    setAttendanceProfileStudent({
      ...student,
      class_id: student.class_id || selectedClass?.id,
      class_name: student.class_name || selectedClass?.name || '',
    });
  };

  const renderTeacherStudentManage = (student) => (
    <Dropdown
      align="end"
      popperConfig={{ strategy: 'fixed' }}
      onToggle={(isOpen) => setOpenTeacherStudentDropdownId(isOpen ? student.id : null)}
    >
      <Dropdown.Toggle size="sm" variant="outline-secondary" className="teacher-student-manage-toggle">
        Actions
      </Dropdown.Toggle>
      <Dropdown.Menu className="shadow teacher-student-dropdown-menu">
        <Dropdown.Item onClick={() => openStudentAttendanceProfile(student)}>
          <i className="bi bi-calendar2-check me-2" aria-hidden="true" />View attendance
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={() => { setOpenTeacherStudentDropdownId(null); openNotesFor(student); }}>
          <i className="bi bi-chat-left-text me-2" aria-hidden="true" />View or add notes
        </Dropdown.Item>
        <Dropdown.Item onClick={() => { setOpenTeacherStudentDropdownId(null); openGoalsFor(student); }}>
          <i className="bi bi-bullseye me-2" aria-hidden="true" />Add or view goals
        </Dropdown.Item>
        <Dropdown.Item onClick={() => { setOpenTeacherStudentDropdownId(null); openQuranAssignmentsFor(student); }}>
          <i className="bi bi-book me-2" aria-hidden="true" />Quran assignments
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={() => openEditTeacherStudent(student)}>
          <i className="bi bi-pencil me-2" aria-hidden="true" />Edit student
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item className="text-danger" onClick={() => openRemoveTeacherStudent(student)}>
          <i className="bi bi-person-dash me-2" aria-hidden="true" />Remove from class
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );

  const handleSaveTeacherStudent = async (e) => {
    e?.preventDefault?.();
    if (!teacherStudentForm.first_name.trim() || !teacherStudentForm.last_name.trim()) {
      toast.warn('First name and last name are required');
      return;
    }

    try {
      if (editingTeacherStudent) {
        await axios.put(
          `${API_URL}/students/teacher/${editingTeacherStudent.id}`,
          teacherStudentForm,
          authHeader()
        );
        toast.success('Student updated');
      } else {
        await axios.post(
          `${API_URL}/students/add`,
          { ...teacherStudentForm, class_id: selectedClassId },
          authHeader()
        );
        toast.success('Student added');
      }

      setShowTeacherStudentModal(false);
      setEditingTeacherStudent(null);
      setTeacherStudentForm(emptyStudentForm);
      await loadClasses();
      await loadDashboardSummary();
    } catch (err) {
      console.error('Teacher student save failed:', err);
      handleApiError(err, err?.response?.data?.error || 'Could not save student');
    }
  };

  const handleRemoveTeacherStudentFromClass = async () => {
    if (!studentToRemove) return;
    try {
      await axios.put(
        `${API_URL}/students/teacher/${studentToRemove.id}/remove-from-class`,
        {},
        authHeader()
      );
      toast.success('Student removed from class');
      setStudentToRemove(null);
      await loadClasses();
      await loadDashboardSummary();
    } catch (err) {
      console.error('Teacher student remove failed:', err);
      handleApiError(err, err?.response?.data?.error || 'Could not remove student from class');
    }
  };

  // ---------- Attendance ----------
  const setAllAttendance = (status) => {
    const currentClass = classes.find(c => c.id === selectedClassId);
    if (!currentClass || !currentClass.students) {
      toast.error('No class or students selected');
      return;
    }
    const updated = {};
    currentClass.students.forEach((s) => { updated[s.id] = status; });
    setAttendance(updated);
    if (status !== 'present') setLateAttendance({});
  };

  const handleAttendanceChange = (studentId, status) => {
    setAttendance(prev => ({ ...prev, [studentId]: status }));
    if (status !== 'present') {
      setLateAttendance(prev => ({ ...prev, [studentId]: false }));
    }
  };

  const handleLateChange = (studentId, checked) => {
    setLateAttendance(prev => ({ ...prev, [studentId]: checked }));
    if (checked) {
      setAttendance(prev => ({ ...prev, [studentId]: 'present' }));
    }
  };

  const handleCommentChange = (studentId, text) => {
    setComments(prev => ({ ...prev, [studentId]: text }));
  };

  const handleSubmitAttendance = async (classId, students) => {
    const attendanceData = students.map(s => ({
      student_id: s.id,
      class_id: classId,
      status: attendance[s.id] || '',
      is_late: attendance[s.id] === 'present' && !!lateAttendance[s.id],
      comment: comments[s.id] || ''
    })).filter(entry => entry.status);

    try {
      await axios.post(`${API_URL}/attendance/mark`, { attendance: attendanceData, date: attendanceDate }, authHeader());
      setAttendance({});
      setLateAttendance({});
      setComments({});
      setAttendanceDate(getLocalDateInputValue());
      setSelectedClassId(null);
      setActiveTab('dashboard');
      toast.success('Attendance completed successfully');
      // refresh summary/graphs so recent data shows without a page reload
      loadDashboardSummary();
    } catch (err) {
      console.error('❌ Attendance submission failed:', err);
      toast.error('Failed to submit attendance');
    }
  };

  // ---------- Notes ----------
  const token = localStorage.getItem('token');

  const loadStudentNotes = async (studentId) => {
    try {
      setNotesLoading(true);
      const res = await fetch(`${API_URL}/students/${studentId}/notes`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Failed to load notes');
      const data = await res.json();
      setNotes(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error(e);
      handleApiError(e, 'Could not load student notes');
    } finally {
      setNotesLoading(false);
    }
  };

  const openNotesFor = async (student) => {
    setNotesStudent(student);
    setShowNotes(true);
    await loadStudentNotes(student.id);
  };

const handleAddStudentNote = async (e) => {
  e.preventDefault();
  if (!newNoteText?.trim()) return toast.warn('Please type a note first');

  try {
    const { data } = await axios.post(
      `${API_URL}/students/${notesStudent.id}/notes`,
      { note_text: newNoteText.trim() },
      authHeader()
    );
    setNotes(prev => [data, ...prev]);  // update modal list
    setNewNoteText('');
    toast.success('Note added');

    // 🔁 Refresh dashboard summary so "Recent Notes" updates immediately
    await loadDashboardSummary();
  } catch (err) {
    console.error('Add note failed', err?.response?.status, err?.response?.data);
    toast.error(`Failed to add note${err?.response?.status ? ` (${err.response.status})` : ''}`);
  }
};

  const startEditNote = (note) => {
    setEditingNoteId(note.id);
    setEditingNoteText(note.note_text);
  };

  const cancelEditNote = () => {
    setEditingNoteId(null);
    setEditingNoteText('');
  };

  const handleSaveStudentNote = async () => {
    if (!editingNoteText?.trim()) return toast.warn('Note cannot be empty');
    try {
      const res = await fetch(`${API_URL}/students/${notesStudent.id}/notes/${editingNoteId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ note_text: editingNoteText.trim() })
      });
      if (!res.ok) throw new Error('Failed to update note');
      const updated = await res.json();
      setNotes(prev =>
        prev.map(n => (n.id === editingNoteId
          ? (updated?.id ? updated : { ...n, note_text: editingNoteText })
          : n))
      );
      cancelEditNote();
      toast.success('Note updated');
    } catch (e) {
      console.error(e);
      toast.error('Failed to update note');
    }
  };

  const confirmDeleteStudentNote = (note) => {
    setNoteToDelete({ id: note.id, text: note.note_text });
  };

  const handleDeleteStudentNote = async () => {
    try {
      const res = await fetch(`${API_URL}/students/${notesStudent.id}/notes/${noteToDelete.id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Failed to delete note');
      setNotes(prev => prev.filter(n => n.id !== noteToDelete.id));
      setNoteToDelete(null);
      toast.success('Note deleted');
    } catch (e) {
      console.error(e);
      toast.error('Failed to delete note');
    }
  };

  const fmtDateTime = (s) => {
    try { return new Date(s).toLocaleString(); } catch { return s; }
  };

// ===============================
// ⭐ Student Goals (CRUD) — mirrors Notes
// ===============================
const VALID_TERMS = new Set(['year', 'semester', 'custom']);

// use the same token logic you already have above for Notes


const loadStudentGoals = async (studentId) => {
  try {
    setGoalsLoading(true);
    const res = await fetch(`${API_URL}/students/${studentId}/goals`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error('Failed to load goals');
    const data = await res.json();
    setGoals(Array.isArray(data) ? data : []);
  } catch (e) {
    console.error(e);
    toast.error('Could not load student goals');
  } finally {
    setGoalsLoading(false);
  }
};

const openGoalsFor = async (student) => {
  setGoalsStudent(student);
  setShowGoals(true);
  await loadStudentGoals(student.id);
};

const handleAddStudentGoal = async (e) => {
  e.preventDefault();
  if (!newGoalText?.trim()) return toast.warn('Please type a goal first');

  try {
    const payload = {
      goal_text: newGoalText.trim(),
      term: newGoalTerm || 'Weekend',
      status: newGoalStatus || 'in-progress',
      due_date: newGoalDueDate || null,
    };

    const { data } = await axios.post(
      `${API_URL}/students/${goalsStudent.id}/goals`,
      payload,
      authHeader()
    );

    setGoals(prev => [data, ...prev]);
    setNewGoalText('');
    setNewGoalTerm('');
    setNewGoalStatus('in-progress');
    setNewGoalDueDate('');
    toast.success('Goal added');
  } catch (err) {
    console.error('Add goal failed', err?.response?.status, err?.response?.data);
    toast.error(`Failed to add goal${err?.response?.status ? ` (${err.response.status})` : ''}`);
  }
};


const startEditGoal = (goal) => {
  setEditingGoalId(goal.id);
  setEditingGoalText(goal.goal_text);
  setEditingGoalTerm(goal.term || '');
  setEditingGoalStatus(goal.status || 'in-progress');
  setEditingGoalDueDate(goal.due_date || '');
};

const cancelEditGoal = () => {
  setEditingGoalId(null);
  setEditingGoalText('');
  setEditingGoalTerm('');
  setEditingGoalStatus('');
  setEditingGoalDueDate('');
};


const handleSaveStudentGoal = async () => {
  if (!editingGoalText?.trim()) return toast.warn('Goal cannot be empty');
  try {
    const payload = {
      goal_text: editingGoalText.trim(),
      term: editingGoalTerm || 'Weekend',
      status: editingGoalStatus || 'in-progress',
      due_date: editingGoalDueDate || null,
    };

    const res = await fetch(`${API_URL}/students/${goalsStudent.id}/goals/${editingGoalId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    });

    if (!res.ok) throw new Error('Failed to update goal');
    const updated = await res.json();

    setGoals(prev =>
      prev.map(g => (g.id === editingGoalId
        ? (updated?.id ? updated : { ...g, ...payload })
        : g))
    );

    cancelEditGoal();
    toast.success('Goal updated');
  } catch (e) {
    console.error(e);
    toast.error('Failed to update goal');
  }
};


const confirmDeleteStudentGoal = (goal) => {
  setGoalToDelete({ id: goal.id, text: goal.goal_text });
};

const handleDeleteStudentGoal = async () => {
  try {
    const res = await fetch(`${API_URL}/students/${goalsStudent.id}/goals/${goalToDelete.id}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error('Failed to delete goal');
    setGoals(prev => prev.filter(g => g.id !== goalToDelete.id));
    setGoalToDelete(null);
    toast.success('Goal deleted');
  } catch (e) {
    console.error(e);
    toast.error('Failed to delete goal');
  }
};

const loadQuranAssignments = async (studentId) => {
  try {
    setQuranAssignmentsLoading(true);
    const { data } = await axios.get(`${API_URL}/students/${studentId}/quran-assignments`, authHeader());
    setQuranAssignments(Array.isArray(data) ? data : []);
  } catch (error) {
    console.error('Load Quran assignments failed', error);
    handleApiError(error, 'Could not load Quran assignments');
  } finally {
    setQuranAssignmentsLoading(false);
  }
};

const openQuranAssignmentsFor = async (student) => {
  setQuranStudent(student);
  setQuranAssignmentForm(emptyQuranAssignment);
  setShowQuranAssignments(true);
  await loadQuranAssignments(student.id);
};

const handleQuranSurahChange = (value) => {
  setQuranAssignmentForm(previous => ({
    ...previous,
    surah_number: value,
    start_verse: '1',
    end_verse: '1',
  }));
};

const handleAddQuranAssignment = async (event) => {
  event.preventDefault();
  if (!quranAssignmentForm.surah_number) {
    toast.warn('Please select a surah');
    return;
  }

  try {
    setQuranAssignmentSaving(true);
    const { data } = await axios.post(
      `${API_URL}/students/${quranStudent.id}/quran-assignments`,
      quranAssignmentForm,
      authHeader()
    );
    setQuranAssignments(previous => [data, ...previous]);
    setQuranAssignmentForm(emptyQuranAssignment);
    loadDashboardSummary();
    toast.success('Quran assignment added');
  } catch (error) {
    console.error('Add Quran assignment failed', error);
    toast.error(error?.response?.data?.error || 'Failed to add Quran assignment');
  } finally {
    setQuranAssignmentSaving(false);
  }
};

const handleQuranAssignmentStatus = async (assignment) => {
  const status = assignment.status === 'completed' ? 'assigned' : 'completed';
  try {
    await axios.patch(
      `${API_URL}/students/${quranStudent.id}/quran-assignments/${assignment.id}`,
      { status },
      authHeader()
    );
    setQuranAssignments(previous => previous.map(item => item.id === assignment.id ? { ...item, status } : item));
    loadDashboardSummary();
    toast.success(status === 'completed' ? 'Assignment completed' : 'Assignment reopened');
  } catch (error) {
    console.error('Update Quran assignment failed', error);
    toast.error('Failed to update Quran assignment');
  }
};

const handleDeleteQuranAssignment = async (assignment) => {
  if (!window.confirm(`Delete the ${assignment.surah_name} assignment?`)) return;
  try {
    await axios.delete(
      `${API_URL}/students/${quranStudent.id}/quran-assignments/${assignment.id}`,
      authHeader()
    );
    setQuranAssignments(previous => previous.filter(item => item.id !== assignment.id));
    loadDashboardSummary();
    toast.success('Quran assignment deleted');
  } catch (error) {
    console.error('Delete Quran assignment failed', error);
    toast.error('Failed to delete Quran assignment');
  }
};






  // ---------- Reports ----------
 const handleGenerateReport = async () => {
  const res = await axios.post(`${API_URL}/attendance/report`, reportFilters, authHeader());
  const rows = res.data || [];
  setReport(rows);

  const insights = computeAttendanceInsights(rows);
  setReportInsights(insights);
  setShowReportModal(true);
};



  const handleExportPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text('Attendance Report', 14, 15);
    autoTable(doc, {
      startY: 20,
      head: [['Date', 'First Name', 'Last Name', 'Status', 'Late', 'Comment']],
      body: report.map(r => [
        formatDateOnly(r.date),
        r.first_name, r.last_name, r.status, r.is_late ? 'Yes' : 'No', r.comment || ''
      ])
    });
    doc.save('Attendance_Report.pdf');
  };

const handleExportInsightsPDF = async () => {
  try {
    const doc = new jsPDF();
    const margin = 14;

    doc.setFontSize(16);
    doc.text('Attendance Insights', margin, 16);
    doc.setFontSize(11);
    doc.text(
      `Meetings: ${reportInsights.totalMeetings} | Students: ${Object.keys(reportInsights.byStudent).length}`,
      margin,
      24
    );

    let y = 34;
    doc.setFontSize(13);
    doc.text('Best Attendance', margin, y);
    y += 8;
    doc.setFontSize(11);
    doc.text(
      reportInsights.bestStudents?.length
        ? `${reportInsights.bestStudents.length} student(s) tied at ${reportInsights.bestStudent.pct}%: ${reportInsights.bestStudents.map((s) => s.name).join(', ')}`
        : 'No attendance summary available.',
      margin,
      y
    );

    y += 14;
    doc.setFontSize(13);
    doc.text('Needs Attention', margin, y);
    y += 8;
    doc.setFontSize(11);
    doc.text(
      reportInsights.worstStudents?.length
        ? `${reportInsights.worstStudents.length} student(s) with ${reportInsights.worstStudent.absent} absent day(s): ${reportInsights.worstStudents.map((s) => s.name).join(', ')}`
        : 'No attendance summary available.',
      margin,
      y
    );

    doc.addPage();
    doc.setFontSize(14);
    doc.text('Leaderboard', margin, 16);

    const rows = reportInsights.ranked
      .map((s, idx) => [idx + 1, s.name, s.present, s.late, s.absent, s.excused, s.total, `${s.pct}%`]);

    autoTable(doc, {
      startY: 22,
      head: [['#', 'Name', 'Present', 'Late', 'Absent', 'Excused', 'Total', 'Present %']],
      body: rows,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [41, 128, 185] },
      margin: { left: margin, right: margin },
    });

    doc.save('Attendance_Insights.pdf');
  } catch (err) {
    console.error('Export insights failed:', err);
    toast.error('Failed to export insights');
  }
};

const handlePrintReport = () => {
  window.print();
};

const buildAttendanceReportShareText = () => {
  const best = reportInsights.bestStudents?.length
    ? `${reportInsights.bestStudents.length} student(s) tied at ${reportInsights.bestStudent?.pct}%: ${reportInsights.bestStudents.map((s) => s.name).join(', ')}`
    : 'No best attendance summary available';
  const needsAttention = reportInsights.worstStudents?.length
    ? `${reportInsights.worstStudents.length} student(s) with ${reportInsights.worstStudent?.absent} absent day(s): ${reportInsights.worstStudents.map((s) => s.name).join(', ')}`
    : 'No needs-attention summary available';

  return [
    'Attendance Report',
    `Meetings: ${reportInsights.totalMeetings}`,
    `Students tracked: ${Object.keys(reportInsights.byStudent || {}).length}`,
    `Best Attendance: ${best}`,
    `Needs Attention: ${needsAttention}`,
    `Late arrivals: ${(reportInsights.ranked || []).reduce((sum, s) => sum + (Number(s.late) || 0), 0)}`
  ].join('\n');
};

const handleShareAttendanceReport = async () => {
  const text = buildAttendanceReportShareText();
  try {
    if (navigator.share) {
      await navigator.share({ title: 'Attendance Report', text });
      return;
    }
    await navigator.clipboard.writeText(text);
    toast.success('Attendance report summary copied');
  } catch (err) {
    if (err?.name !== 'AbortError') {
      console.error('Share attendance report failed:', err);
      toast.error('Could not share report');
    }
  }
};

const isSingleStudentReport = Boolean(reportFilters.student_id);

const dismissMobilePicker = () => {
  const activeEl = document.activeElement;
  if (
    activeEl &&
    typeof activeEl.blur === 'function' &&
    ['INPUT', 'SELECT', 'TEXTAREA'].includes(activeEl.tagName)
  ) {
    activeEl.blur();
  }
};





  const handleLogout = () => {
    logout();
    navigate('/');
  };

const handleClearReport = () => {
  setReport([]);
  setReportFilters({ class_id: '', student_id: '', start_date: '', end_date: '' });
};

  // Load existing attendance for a class/date (to allow corrections)
  const loadAttendanceForDate = async (classId, dateStr) => {
    if (!classId || !dateStr) return;
    setAttendance({});
    setLateAttendance({});
    setComments({});
    try {
      const { data } = await axios.post(
        `${API_URL}/attendance/report`,
        { class_id: classId, start_date: dateStr, end_date: dateStr },
        authHeader()
      );
      const attMap = {};
      const lateMap = {};
      const commentMap = {};
      (data || []).forEach((row) => {
        if (row.student_id) {
          attMap[row.student_id] = row.status || '';
          lateMap[row.student_id] = (row.status === 'present') && (Number(row.is_late) === 1 || row.is_late === true);
          if (row.comment) commentMap[row.student_id] = row.comment;
        }
      });
      setAttendance(attMap);
      setLateAttendance(lateMap);
      setComments(commentMap);
    } catch (err) {
      console.error('Failed to load attendance for date', err);
      handleApiError(err, 'Could not load attendance for this date');
    }
  };

  const selectedQuranChapter = quranChapters.find(
    chapter => String(chapter.number) === String(quranAssignmentForm.surah_number)
  );

  // ---------- Render ----------
  return (
    <div className="teacher-dashboard-wrapper d-flex">

      {/* Sidebar */}
      <Offcanvas
        show={sidebarOpen}
        onHide={() => setSidebarOpen(false)}
        placement="start"
        responsive="lg"
        className="sidebar"
      >
        <Offcanvas.Header closeButton className="text-white">
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="d-flex flex-column gap-2 overflow-auto">
          <Button variant="outline-primary" onClick={() => handleSidebarNav('dashboard')}>
            <BiHomeAlt className="me-2" /> Dashboard
          </Button>

          <Accordion alwaysOpen flush className="custom-accordion">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <BiChalkboard className="me-2" />
                Classes
              </Accordion.Header>
              <Accordion.Body>
                {classes.length === 0 ? (
                  <div>No classes assigned yet</div>
                ) : (
                  classes.map((cls) => (
                    <button
                      key={cls.id}
                      className={`subtab-buttons ${selectedClassId === cls.id ? 'active-subtab' : ''}`}
                      onClick={() => {
                        openClassView(cls.id); // always open Names + Notes first
                        setSidebarOpen(false);
                      }}
                    >
                      <BiChalkboard className="me-2" />
                      {cls.name}
                    </button>
                  ))
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <Button
            variant="outline-dark"
            onClick={() => {
              setActiveTab('report');
              setSidebarOpen(false);
            }}
          >
            <BiBarChartAlt className="me-2" /> Reporting
          </Button>

          <Button variant="outline-danger" className="dashboard-logout-btn" onClick={handleLogout}>
            <BiLogOut className="me-2" /> Logout
          </Button>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Main */}
      <Container className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <Button
            variant="dark"
            className="d-lg-none menu-toggle-btn"
            onClick={() => setSidebarOpen(true)}
          >
            <i className="bi bi-list"></i>
          </Button>
          <DashboardUserMenu />
        </div>

        {/* DASHBOARD */}
        {activeTab === 'dashboard' && (
          <>
    <Card className="teacher-welcome mb-4">
      <Card.Body className="teacher-welcome__body">
        <div className="teacher-welcome__copy">
          <span className="teacher-welcome__eyebrow">Class overview</span>
          <h1 className="teacher-welcome__title">Welcome back, {currentUser?.name || 'Teacher'} <span aria-hidden="true">👋</span></h1>
          <p className="teacher-welcome__description">View your classes, attendance, and student notes.</p>
        </div>
        <div className="teacher-welcome__date">
          <i className="bi bi-calendar3" aria-hidden="true" />
          <div>
            <span className="teacher-welcome__date-label">Today</span>
            <span>{new Date().toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}</span>
          </div>
        </div>
      </Card.Body>

          <DashboardOverview embedded items={[]}>
            <div className="teacher-quick-actions">
              <div className="teacher-quick-actions__intro">
                <span>Your classes</span>
                <p>Choose what you want to do for each class.</p>
              </div>
              {!classes.length ? (
                <div className="teacher-panel-empty teacher-quick-actions__empty">
                  <i className="bi bi-easel" aria-hidden="true" />
                  <strong>No classes assigned yet</strong>
                  <p>Your admin can assign a class to get you started.</p>
                </div>
              ) : (
                <div className="teacher-quick-actions__classes">
                  {classes.map(cls => (
                    <article className="teacher-quick-class teacher-quick-class--clickable" key={cls.id}>
                      <div className="teacher-quick-class__summary">
                        <div className="teacher-quick-class__icon"><BiChalkboard aria-hidden="true" /></div>
                        <div>
                          <h2>{cls.name}</h2>
                          <p><strong>{cls.students?.length || 0}</strong> {(cls.students?.length || 0) === 1 ? 'student' : 'students'}</p>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="teacher-quick-class__open"
                        aria-label={`View students in ${cls.name}`}
                        onClick={() => openClassView(cls.id)}
                      />
                      <div className="teacher-quick-class__actions">
                        <Button variant="outline-primary" onClick={() => openClassView(cls.id)}>
                          <i className="bi bi-people" aria-hidden="true" />View students
                        </Button>
                        <Button variant="primary" onClick={() => openAttendanceView(cls.id)}>
                          <i className="bi bi-clipboard2-check" aria-hidden="true" />Take attendance
                        </Button>
                        <Button variant="light" onClick={() => {
                          setReportFilters(previous => ({ ...previous, class_id: String(cls.id), student_id: '' }));
                          handleSidebarNav('report');
                        }}>
                          <i className="bi bi-bar-chart" aria-hidden="true" />Attendance report
                        </Button>
                      </div>
                    </article>
                  ))}
                </div>
              )}
              </div>
          </DashboardOverview>
    </Card>

          <section className="teacher-attention" aria-labelledby="teacher-attention-title">
            <div className="teacher-attention__heading">
              <div>
                <span>Today</span>
                <h2 id="teacher-attention-title">Needs attention</h2>
                <p>Follow up with students who may need support.</p>
              </div>
              <span className="teacher-attention__total">
                {dashboardLoading
                  ? '…'
                  : (dashboardSummary?.needsAttention?.studentsWithRepeatedAbsences?.length || 0) +
                    (dashboardSummary?.needsAttention?.overdueQuranAssignments?.length || 0)}
              </span>
            </div>
            <div className="teacher-attention__grid">
              <article className="teacher-attention-group teacher-attention-group--absence">
                <div className="teacher-attention-group__heading">
                  <i className="bi bi-person-exclamation" aria-hidden="true" />
                  <div><h3>Students absent multiple times</h3><p>Two or more absences in the last 30 days</p></div>
                  <span>{dashboardSummary?.needsAttention?.studentsWithRepeatedAbsences?.length || 0}</span>
                </div>
                {dashboardLoading ? (
                  <div className="teacher-attention__empty">Checking attendance…</div>
                ) : dashboardSummary?.needsAttention?.studentsWithRepeatedAbsences?.length ? (
                  <div className="teacher-attention-list">
                    {dashboardSummary.needsAttention.studentsWithRepeatedAbsences.map((student) => (
                      <button type="button" key={`${student.id}-${student.class_id}`} onClick={() => openStudentAttendanceProfile(student)}>
                        <span><strong>{student.first_name} {student.last_name}</strong><small>{student.class_name} · {student.absence_count} absences</small></span>
                        <i className="bi bi-arrow-right" aria-hidden="true" />
                      </button>
                    ))}
                  </div>
                ) : (
                  <div className="teacher-attention__empty teacher-attention__empty--success"><i className="bi bi-check-circle" aria-hidden="true" />No repeated absences</div>
                )}
              </article>

              <article className="teacher-attention-group teacher-attention-group--quran">
                <div className="teacher-attention-group__heading">
                  <i className="bi bi-book" aria-hidden="true" />
                  <div><h3>Overdue Quran assignments</h3><p>Assignments past their due date</p></div>
                  <span>{dashboardSummary?.needsAttention?.overdueQuranAssignments?.length || 0}</span>
                </div>
                {dashboardLoading ? (
                  <div className="teacher-attention__empty">Checking assignments…</div>
                ) : dashboardSummary?.needsAttention?.overdueQuranAssignments?.length ? (
                  <div className="teacher-attention-list">
                    {dashboardSummary.needsAttention.overdueQuranAssignments.map((assignment) => (
                      <button type="button" key={assignment.assignment_id} onClick={() => openQuranAssignmentsFor(assignment)}>
                        <span><strong>{assignment.first_name} {assignment.last_name}</strong><small>{assignment.surah_name} {assignment.start_verse}–{assignment.end_verse} · Due {formatDateOnly(assignment.due_date)}</small></span>
                        <i className="bi bi-arrow-right" aria-hidden="true" />
                      </button>
                    ))}
                  </div>
                ) : (
                  <div className="teacher-attention__empty teacher-attention__empty--success"><i className="bi bi-check-circle" aria-hidden="true" />No overdue assignments</div>
                )}
              </article>
            </div>
          </section>

          {/* Per-class last 7 days attendance */}

          {/* Notes + To-Do in middle row */}
          <Row className="g-3 mb-4">
            <Col lg={8}>
              <Card
                id="teacher-student-notes" tabIndex={-1} aria-label="Recent student notes" className="teacher-section-card shadow-sm border-0 rounded-4 overflow-hidden h-100"
              >
                <Card.Header
                  className="teacher-section-header fw-semibold text-dark d-flex justify-content-between align-items-center"
                >
                  <div className="teacher-panel-heading"><i className="bi bi-chat-left-text" aria-hidden="true" /><div><h2>Student notes</h2><p>Updates from the last 7 days</p></div></div>
                  <span className="teacher-section-count">{dashboardLoading ? '…' : `${dashboardSummary?.recentNotes?.length || 0} notes`}</span>
                </Card.Header>
                <Card.Body className="p-3">
                  {dashboardLoading ? (
                    <div className="text-muted small">Loading…</div>
                  ) : !dashboardSummary?.recentNotes ||
                    dashboardSummary.recentNotes.length === 0 ? (
                    <div className="teacher-panel-empty"><i className="bi bi-chat-left-text" aria-hidden="true" /><strong>No recent student notes</strong><p>Open a class, then choose Notes beside a student to add an update.</p></div>
                  ) : (
                    <>
                      {!isMobile && (
                        <div className="table-responsive">
                          <Table size="sm" className="mb-0 align-middle">
                            <thead>
                              <tr>
                                <th>Student</th>
                                <th>Class</th>
                                <th>Note</th>
                                <th>Created</th>
                                <th style={{ width: 90 }}></th>
                              </tr>
                            </thead>
                            <tbody>
                              {dashboardSummary.recentNotes.slice(0, 4).map((n) => {
                                const student = {
                                  id: n.student_id,
                                  first_name: n.student_first_name,
                                  last_name: n.student_last_name,
                                };
                                return (
                                  <tr key={n.id}>
                                    <td className="small fw-semibold">{n.student_first_name} {n.student_last_name}</td>
                                    <td className="small text-muted">{n.class_name}</td>
                                    <td>
                                      <span
                                        className="small"
                                        style={{
                                          display: 'inline-block',
                                          maxWidth: 260,
                                        }}
                                      >
                                        {n.note_text?.length > 80
                                          ? n.note_text.slice(0, 80) + '…'
                                          : n.note_text}
                                      </span>
                                    </td>
                                    <td className="small text-muted">
                                      {fmtDateTime(n.created_at)}
                                    </td>
                                    <td className="text-end">
                                      <Button
                                        size="sm"
                                        variant="outline-primary"
                                        className="teacher-btn-soft"
                                        onClick={() => openNotesFor(student)}
                                      >
                                        View
                                      </Button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      )}

                      {isMobile && (
                        <Row xs={1} className="g-2 mt-2">
                          {dashboardSummary.recentNotes.slice(0, 4).map((n) => {
                            const student = {
                              id: n.student_id,
                              first_name: n.student_first_name,
                              last_name: n.student_last_name,
                            };
                            return (
                              <Col key={n.id}>
                        <Card className="shadow-sm teacher-card-surface">
                                  <Card.Body className="p-3">
                                    <div className="d-flex justify-content-between align-items-start mb-1">
                                      <div>
                                        <div className="fw-semibold">
                                          {n.student_first_name} {n.student_last_name}
                                        </div>
                                        <div className="small text-muted">
                                          {n.class_name}
                                        </div>
                                      </div>
                                      <small className="text-muted ms-2">
                                        {fmtDateTime(n.created_at)}
                                      </small>
                                    </div>

                                    <div className="small mb-2 text-muted"
                                      style={{
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                      }}
                                    >
                                      {n.note_text}
                                    </div>

                                    <div className="d-flex justify-content-end">
                                      <Button
                                        size="sm"
                                        variant="outline-primary"
                                        className="teacher-btn-soft"
                                        onClick={() => openNotesFor(student)}
                                      >
                                        View
                                      </Button>
                                    </div>
                                  </Card.Body>
                                </Card>
                              </Col>
                            );
                          })}
                        </Row>
                      )}
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4}>
              <Card
                id="teacher-tasks" tabIndex={-1} aria-label="Your tasks" className="teacher-section-card shadow-sm border-0 rounded-4 overflow-hidden h-100"
              >
                <Card.Header
                  className="teacher-section-header teacher-section-header--green fw-semibold text-dark d-flex align-items-center"
                >
                  <div className="teacher-panel-heading"><BiCheckSquare size={22} aria-hidden="true" /><div><h2>Your tasks</h2><p>Keep track of what needs doing</p></div></div><span className="teacher-section-count ms-auto">{todos.filter(task => !task.done).length} open</span>
                </Card.Header>
                <Card.Body className="pt-3 pb-3">
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      addTodo(todoText);
                      setTodoText('');
                    }}
                  >
                    <InputGroup className="mb-3">
                      <Form.Control
                        size="sm"
                        placeholder="What needs to be done?" aria-label="New task"
                        value={todoText}
                        onChange={(e) => setTodoText(e.target.value)}
                        className="rounded-start-3"
                      />
                      <Button type="submit" variant="success" className="rounded-end-3 px-3 teacher-btn-success" disabled={!todoText.trim()}>
                        Add
                      </Button>
                    </InputGroup>
                  </Form>

                  {todos.length === 0 ? (
                    <div className="teacher-panel-empty"><i className="bi bi-check2-circle" aria-hidden="true" /><strong>No tasks yet</strong><p>Add your first task above.</p></div>
                  ) : (
                    <ListGroup variant="flush">
                      {todos.map((t) => (
                        <ListGroup.Item
                          key={t.id}
                          className="d-flex justify-content-between align-items-center"
                          style={{
                            backgroundColor: '#fff',
                            borderRadius: '0.75rem',
                            marginBottom: '0.5rem',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.06)',
                          }}
                        >
                          <div
                            className="d-flex align-items-center gap-2 flex-wrap"
                            style={{ cursor: 'pointer' }}
                            onClick={() => toggleTodo(t)}
                          >
                            <Form.Check
                              type="checkbox"
                              checked={!!t.done}
                              onChange={() => {}}
                            />
                            <span style={{ textDecoration: t.done ? 'line-through' : 'none' }}>
                              {t.text}
                            </span>
                          </div>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            className="teacher-btn-danger"
                            onClick={() => deleteTodo(t.id)}
                          >
                            Delete
                          </Button>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Per-class mini charts (last 7 days) */}
          {!dashboardLoading && dashboardSummary?.attendanceByClassDaily?.length > 0 && (
            <Card className="teacher-section-card shadow-sm border-0 rounded-4 mb-4">
              <Card.Body className="p-3 p-md-4">
                <div className="mb-2">
                  <h5 className="mb-1 text-dark">Attendance · last 7 days</h5>
                  <p className="mb-0 text-muted small">On-time, late, absent, and excused counts for each class this week.</p>
                </div>
                <Row className="g-3">
                  {Object.values(
                (dashboardSummary.attendanceByClassDaily || []).reduce((acc, row) => {
                  if (!acc[row.class_id]) {
                    acc[row.class_id] = { ...row, days: [] };
                  }
                  acc[row.class_id].days.push(row);
                  return acc;
                }, {})
              ).map((c) => {
                const displayedDays = c.days.filter((d) => d.date && d.totalMarked > 0);
                if (!displayedDays.length) return null;

                const labels = displayedDays.map((d) => formatDateOnly(d.date)).filter(Boolean);
                const presentTotal = displayedDays.reduce((sum, d) => sum + d.presentCount, 0);
                const absentTotal = displayedDays.reduce((sum, d) => sum + d.absentCount, 0);
                const countedTotal = presentTotal + absentTotal;
                const pctPresent = countedTotal ? Math.round((presentTotal / countedTotal) * 100) : 0;
                const latestDay = displayedDays[displayedDays.length - 1];
                const selectedDayIndex = Number.isInteger(selectedAttendanceChartDays[c.class_id])
                  ? Math.min(selectedAttendanceChartDays[c.class_id], displayedDays.length - 1)
                  : displayedDays.length - 1;
                const selectedDay = displayedDays[selectedDayIndex] || latestDay;
                const chartData = {
                  labels,
                  datasets: [
                    {
                      label: 'On Time',
                      data: displayedDays.map((d) => Math.max((d.presentCount || 0) - (d.lateCount || 0), 0)),
                      backgroundColor: '#2ca56f',
                      borderRadius: 4,
                      barPercentage: 0.5,
                    },
                    {
                      label: 'Late',
                      data: displayedDays.map((d) => d.lateCount || 0),
                      backgroundColor: '#f59e0b',
                      borderRadius: 4,
                      barPercentage: 0.5,
                    },
                    {
                      label: 'Absent',
                      data: displayedDays.map((d) => d.absentCount || 0),
                      backgroundColor: '#e55353',
                      borderRadius: 4,
                      barPercentage: 0.5,
                    },
                    {
                      label: 'Excused',
                      data: displayedDays.map((d) => d.excusedCount || 0),
                      backgroundColor: '#3fa3ff',
                      borderRadius: 4,
                      barPercentage: 0.5,
                    },
                  ],
                };
                const chartOpts = {
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: { display: false },
                    tooltip: {
                      callbacks: { label: (ctx) => `${ctx.dataset.label}: ${ctx.parsed.y}` },
                    },
                  },
                  onClick: (_, elements) => {
                    if (!elements?.length) return;
                    const clickedIndex = elements[0]?.index;
                    if (!Number.isInteger(clickedIndex)) return;
                    setSelectedAttendanceChartDays((prev) => ({
                      ...prev,
                      [c.class_id]: clickedIndex,
                    }));
                  },
                  scales: {
                    x: { stacked: true, grid: { display: false }, ticks: { color: '#6c757d' } },
                    y: { stacked: true, beginAtZero: true, ticks: { precision: 0, color: '#6c757d' }, grid: { color: 'rgba(0,0,0,0.05)' } },
                  },
                };

                    return (
                      <Col md={6} sm={12} key={c.class_id}>
                        <Card
                          className="teacher-card-surface shadow-sm h-100"
                        >
                          <Card.Body>
                            <div className="d-flex justify-content-between align-items-start mb-1">
                              <div>
                                <div className="fw-semibold">{c.class_name || 'Class'}</div>
                                <div className="small text-muted">{c.shift || ''}</div>
                              </div>
                              <div className="text-end">
                              <div className="fw-bold">{pctPresent}%</div>
                                <div className="small text-muted">present rate</div>
                              </div>
                            </div>
                            <div style={{ height: 140 }}>
                              <Bar data={chartData} options={chartOpts} />
                            </div>
                            <div className="small text-muted mt-2">
                              Selected day: {formatDateOnly(selectedDay?.date)} • tap a bar to switch days
                            </div>
                            <div className="teacher-attendance-legend mt-3">
                              <div className="teacher-attendance-legend__item">
                                <span className="teacher-attendance-legend__dot teacher-attendance-legend__dot--present" />
                                <span>Present: {selectedDay?.presentCount || 0}</span>
                              </div>
                              <div className="teacher-attendance-legend__item">
                                <span className="teacher-attendance-legend__dot teacher-attendance-legend__dot--late" />
                                <span>Late: {selectedDay?.lateCount || 0}</span>
                              </div>
                              <div className="teacher-attendance-legend__item">
                                <span className="teacher-attendance-legend__dot teacher-attendance-legend__dot--absent" />
                                <span>Absent: {selectedDay?.absentCount || 0}</span>
                              </div>
                              <div className="teacher-attendance-legend__item">
                                <span className="teacher-attendance-legend__dot teacher-attendance-legend__dot--excused" />
                                <span>Excused: {selectedDay?.excusedCount || 0}</span>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              </Card.Body>
            </Card>
          )}

          {/* Your tasks */}

          </>
        )}


        {/* CLASS VIEW (names + notes only) */}
        {activeTab === 'classView' && selectedClassId && (() => {
          const cls = classes.find((c) => c.id === selectedClassId);
          if (!cls) return <p>Class not found.</p>;

          return (
            <Card className="mb-4" key={`${cls.id}-view`}>
              <Card.Body>
                <div className="teacher-class-header d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                  <h5 className="mb-0">{cls.name} — Students</h5>
                  <div className="teacher-class-actions d-flex gap-2">
                    <Button variant="primary" size="sm" onClick={() => openAttendanceView(cls.id)}>
                      Take attendance
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => { setSelectedClassId(null); setActiveTab('dashboard'); }}
                    >
                      ← Back to overview
                    </Button>
                  </div>
                </div>

                {Array.isArray(cls.students) && cls.students.length > 0 ? (
                  <>
                    {!isMobile && (
                      <Table striped bordered responsive size="sm" className="teacher-student-table-simple align-middle">
                       <thead>
                          <tr>
                            <th>Name</th>
                            <th>Actions</th>
                          </tr>
                        </thead>

                        <tbody>
                          {cls.students.map((s) => (
                            <tr key={s.id}>
                              <td className="teacher-student-name">
                                <button type="button" className="teacher-student-profile-link" onClick={() => openStudentAttendanceProfile({ ...s, class_id: cls.id, class_name: cls.name })}>
                                  {s.first_name} {s.last_name}
                                </button>
                              </td>
                              <td>
                                {renderTeacherStudentManage(s)}
                              </td>
                            </tr>
                          ))}
                        </tbody>

                      </Table>
                    )}

                    {isMobile && (
                      <div className="mobile-teacher-student-list">
                        {cls.students.map((s, index) => (
                          <Card
                            key={s.id}
                            className="mb-2 shadow-sm teacher-student-card-mobile"
                            style={{
                              position: 'relative',
                              overflow: 'visible',
                              zIndex: openTeacherStudentDropdownId === s.id ? 5000 : 1,
                            }}
                          >
                            <Card.Body className="p-3">
                              <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                                <div>
                                  <button type="button" className="teacher-student-profile-link fw-semibold" onClick={() => openStudentAttendanceProfile({ ...s, class_id: cls.id, class_name: cls.name })}>
                                    {index + 1}. {s.first_name} {s.last_name}
                                  </button>
                                  <div className="text-muted small">{cls.name}</div>
                                </div>
                              </div>
                              <div className="teacher-student-card__actions mt-3">
                                  {renderTeacherStudentManage(s)}
                              </div>
                            </Card.Body>
                          </Card>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <p>No students in this class yet. Add a student or contact your admin.</p>
                )}
              </Card.Body>
            </Card>
          );
        })()}

{/* CLASS ATTENDANCE */}
{activeTab === 'classAttendance' && selectedClassId && (() => {
  const cls = classes.find((c) => c.id === selectedClassId);
  if (!cls) return <p>Class not found.</p>;

  return (
    <Card className="mb-4" key={`${cls.id}-attendance`}>
      <Card.Body>
        <div className="teacher-class-header d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <h5 className="mb-0">{cls.name} — Attendance</h5>
          <div className="teacher-class-actions d-flex gap-2">
            <Button variant="outline-secondary" size="sm" onClick={() => openClassView(cls.id)}>
              ← Back to Class View
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => { setSelectedClassId(null); setActiveTab('dashboard'); }}
            >
              ← Back to overview
            </Button>
          </div>
        </div>

        <Form.Group className="mb-3" style={{ maxWidth: 220 }}>
          <Form.Label>Date</Form.Label>
          <Form.Control
            type="date"
            value={attendanceDate}
            onChange={(e) => setAttendanceDate(e.target.value)}
          />
        </Form.Group>

        {Array.isArray(cls.students) && cls.students.length > 0 ? (
          <>
            <div className="attendance-submit-bar">
              <div className="attendance-submit-bar__status" aria-live="polite">
                <strong>{cls.students.filter(student => attendance[student.id]).length} of {cls.students.length}</strong>
                <span>students marked</span>
              </div>
              <div className="attendance-submit-bar__actions">
                <Button size="sm" variant="outline-success" onClick={() => setAllAttendance('present')}>
                  Mark all present
                </Button>
                <Button
                  size="sm"
                  variant="success"
                  disabled={!cls.students.some(student => attendance[student.id])}
                  onClick={() => handleSubmitAttendance(cls.id, cls.students)}
                >
                  <i className="bi bi-check2-circle" aria-hidden="true" /> Submit attendance
                </Button>
              </div>
            </div>

            {/* Desktop table — NO Notes column */}
            {!isMobile && (
              <Table striped bordered responsive size="sm">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th style={{ width: 120 }}>Status</th>
                    <th style={{ width: 110 }}>Late</th>
                    <th>Comment</th>
                  </tr>
                </thead>
                <tbody>
                  {cls.students.map((s) => {
                    const status = attendance[s.id] || '';
                    return (
                      <tr key={s.id} className={status ? `attendance-row--${status}` : ''}>
                        <td>{s.first_name} {s.last_name}</td>
                        <td>
                          <Form.Select
                            size="sm"
                            className={`attendance-status-select attendance-status-select--${status || 'empty'}`}
                            value={status}
                            onChange={(e) => handleAttendanceChange(s.id, e.target.value)}
                          >
                            <option value="">--</option>
                            <option value="present">Present</option>
                            <option value="absent">Absent</option>
                            <option value="excused">Excused</option>
                          </Form.Select>
                        </td>
                        <td>
                          <Form.Check
                            type="checkbox"
                            label="Late"
                            checked={!!lateAttendance[s.id]}
                            disabled={status !== 'present'}
                            onChange={(e) => handleLateChange(s.id, e.target.checked)}
                          />
                        </td>
                        <td>
                          <Form.Control
                            size="sm"
                            placeholder="Optional comment"
                            value={comments[s.id] || ''}
                            onChange={(e) => handleCommentChange(s.id, e.target.value)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            )}

            {/* Mobile cards — NO Notes button */}
            {isMobile && (
              <Row xs={1} className="g-3 mb-5">
                {cls.students.map((s) => {
                  const status = attendance[s.id] || '';
                  const borderClass =
                    status === 'present'
                      ? 'border-success'
                      : status === 'absent'
                      ? 'border-danger'
                      : status === 'excused'
                      ? 'border-warning'
                      : 'border-secondary';

                  return (
                    <Col key={s.id}>
                      <Card className={`p-3 shadow-sm border-start border-4 ${borderClass} bg-light attendance-mark-card attendance-mark-card--${status || 'empty'}`}>
                        <Card.Body className="p-2">
                          <h6 className="fw-bold text-primary mb-3">
                            {s.first_name} {s.last_name}
                          </h6>

                          <Form.Group className="mb-3">
                            <Form.Label className="small mb-1">Status</Form.Label>
                            <Form.Select
                              size="sm"
                              className={`attendance-status-select attendance-status-select--${status || 'empty'}`}
                              value={status}
                              onChange={(e) => handleAttendanceChange(s.id, e.target.value)}
                            >
                              <option value="">--</option>
                              <option value="present">Present</option>
                              <option value="absent">Absent</option>
                              <option value="excused">Excused</option>
                            </Form.Select>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Check
                              type="checkbox"
                              label="Arrived late"
                              checked={!!lateAttendance[s.id]}
                              disabled={status !== 'present'}
                              onChange={(e) => handleLateChange(s.id, e.target.checked)}
                            />
                          </Form.Group>

                          <Form.Group>
                            <Form.Label className="small mb-1">Comment</Form.Label>
                            <Form.Control
                              size="sm"
                              placeholder="Optional comment"
                              value={comments[s.id] || ''}
                              onChange={(e) => handleCommentChange(s.id, e.target.value)}
                            />
                          </Form.Group>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            )}
          </>
        ) : (
          <p>No students in this class yet. Add a student or contact your admin.</p>
        )}
      </Card.Body>
    </Card>
  );
})()}


        {/* REPORTS */}
        {activeTab === 'report' && (
          <>
            <Card className="p-4 mb-4">
              <h5 className="mb-2">Attendance reports</h5><p className="teacher-help-text">Choose a class and date range. Select a student to see their individual report.</p>
              <Form className="p-3 rounded shadow-sm bg-light mb-4">
                <Row className="g-2">
                  <Col md={6}>
                    <Form.Label className="fw-semibold">Class</Form.Label>
                    <Form.Select
                      value={reportFilters.class_id}
                      onChange={(e) => setReportFilters({ ...reportFilters, class_id: e.target.value })}
                    >
                      <option value="">Select class</option>
                      {classes.map((cls) => (
                        <option key={cls.id} value={cls.id}>
                          {cls.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>

                  <Col md={6}>
                    <Form.Label className="fw-semibold">Student</Form.Label>
                    <Form.Select
                      value={reportFilters.student_id}
                      onChange={(e) => setReportFilters({ ...reportFilters, student_id: e.target.value })}
                    >
                      <option value="">All students</option>
                      {(() => {
                        const selectedClass = classes.find((c) => c.id === Number(reportFilters.class_id));
                        return Array.isArray(selectedClass?.students)
                          ? selectedClass.students.map((s) => (
                              <option key={s.id} value={s.id}>
                                {s.first_name} {s.last_name}
                              </option>
                            ))
                          : null;
                      })()}
                    </Form.Select>
                  </Col>

                  <Col md={6}>
                    <Form.Label className="fw-semibold">Start Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={reportFilters.start_date}
                      onChange={(e) => setReportFilters({ ...reportFilters, start_date: e.target.value })}
                    />
                  </Col>

                  <Col md={6}>
                    <Form.Label className="fw-semibold">End Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={reportFilters.end_date}
                      onChange={(e) => setReportFilters({ ...reportFilters, end_date: e.target.value })}
                    />
                  </Col>

                  {/* New action row: left = Back & Clear; right = Generate & Cancel */}
                  <Col xs={12} className="d-flex justify-content-between align-items-center gap-2 mt-3 flex-wrap">
                    <div className="d-flex gap-2 mb-2 mb-md-0">
                      <Button
                        variant="outline-dark"
                        onMouseDown={dismissMobilePicker}
                        onTouchStart={dismissMobilePicker}
                        onClick={() => setActiveTab('dashboard')}
                      >
                        ← Back to overview
                      </Button>
                      <Button
                        variant="outline-secondary"
                        onMouseDown={dismissMobilePicker}
                        onTouchStart={dismissMobilePicker}
                        onClick={handleClearReport}
                      >
                        Clear Report
                      </Button>
                    </div>

                    <div className="d-flex gap-2">
                      <Button
                        variant="primary"
                        onMouseDown={dismissMobilePicker}
                        onTouchStart={dismissMobilePicker}
                        onClick={handleGenerateReport}
                      >
                        Generate
                      </Button>
                      <Button
                        variant="secondary"
                        onMouseDown={dismissMobilePicker}
                        onTouchStart={dismissMobilePicker}
                        onClick={handleClearReport}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>

            </Card>

            <Modal
              show={showReportModal}
              onHide={() => setShowReportModal(false)}
              size="lg"
              centered
              dialogClassName="attendance-report-modal"
              fullscreen="sm-down"
            >
              <Modal.Header closeButton className="attendance-report-header">
                <div>
                  <Modal.Title className="attendance-report-title">Attendance Report</Modal.Title>
                  <div className="attendance-report-subtitle">Quick monthly attendance summary with student-level detail</div>
                </div>
              </Modal.Header>
              <Modal.Body className="attendance-report-body">
                {report.length === 0 ? (
                  <p>No attendance records for these filters. Try another class or date range.</p>
                ) : (
                  <>
                    <div className="attendance-report-toolbar">
                      <div>
                        <div className="attendance-section-heading mb-1">Attendance overview</div>
                        <div className="attendance-section-copy">
                          See strongest attendance, weakest attendance, total absences, and the full dated log in one place.
                        </div>
                      </div>
                      <div className="attendance-report-actions">
                        <Button size="sm" variant="outline-dark" className="report-action-btn" onClick={handlePrintReport}>
                          Print
                        </Button>
                        <Button size="sm" variant="outline-primary" className="report-action-btn" onClick={handleExportInsightsPDF}>
                          Download
                        </Button>
                        <Button size="sm" variant="outline-success" className="report-action-btn" onClick={handleShareAttendanceReport}>
                          Share
                        </Button>
                      </div>
                    </div>

                    {!isSingleStudentReport && (
                      <Row className="g-3">
                        <Col md={6}>
                          <Card className="report-chart-card shadow-sm h-100 attendance-highlight-card attendance-highlight-card--best">
                            <Card.Body>
                              <div className="attendance-highlight-label">Best Attendance</div>
                              {reportInsights.bestStudents?.length ? (
                                <>
                                  <div className="attendance-highlight-name">
                                    {reportInsights.bestStudents.length === 1
                                      ? reportInsights.bestStudents[0].name
                                      : `${reportInsights.bestStudents.length} students tied`}
                                  </div>
                                  <div className="attendance-highlight-value">{reportInsights.bestStudent.pct}% present</div>
                                  <div className="attendance-highlight-meta">
                                    {reportInsights.bestStudents.map((student) => student.name).join(', ')}
                                  </div>
                                  <div className="attendance-highlight-meta">
                                    {reportInsights.bestStudents.length === 1
                                      ? `${reportInsights.bestStudent.present} present, ${reportInsights.bestStudent.late} late, ${reportInsights.bestStudent.absent} absent, ${reportInsights.bestStudent.excused} excused`
                                      : `${reportInsights.bestStudents.length} students share the highest present rate.`}
                                  </div>
                                </>
                              ) : (
                                <div className="text-muted small">No absent days found in this range.</div>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>

                        <Col md={6}>
                          <Card className="report-chart-card shadow-sm h-100 attendance-highlight-card attendance-highlight-card--worst">
                            <Card.Body>
                              <div className="attendance-highlight-label">Needs Attention</div>
                              {reportInsights.worstStudents?.length ? (
                                <>
                                  <div className="attendance-highlight-name">
                                    {reportInsights.worstStudents.length === 1
                                      ? reportInsights.worstStudents[0].name
                                      : `${reportInsights.worstStudents.length} students tied`}
                                  </div>
                                  <div className="attendance-highlight-value">{reportInsights.worstStudent.pct}% present</div>
                                  <div className="attendance-highlight-meta">
                                    {reportInsights.worstStudents.map((student) => student.name).join(', ')}
                                  </div>
                                  <div className="attendance-highlight-meta">
                                    {reportInsights.worstStudents.length === 1
                                      ? `${reportInsights.worstStudent.absent} absent day(s), ${reportInsights.worstStudent.present} present, ${reportInsights.worstStudent.late} late, ${reportInsights.worstStudent.excused} excused`
                                      : `${reportInsights.worstStudents.length} students share the most absent days.`}
                                  </div>
                                </>
                              ) : (
                                <div className="text-muted small">No attendance data found in this range.</div>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    )}

                    <Card className={`shadow-sm report-table-card attendance-table-card ${isSingleStudentReport ? '' : 'mt-3'}`}>
                      <Card.Body>
                        <div className="attendance-section-heading">Attendance Log</div>
                        <div className="attendance-section-copy mb-3">Each attendance mark by date for the selected filters.</div>
                        <Table striped={false} bordered={false} hover responsive size="sm" className="report-table attendance-records-table mb-0 d-none d-md-table">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Name</th>
                              <th>Status</th>
                              <th>Late</th>
                              <th>Comment</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(() => {
                              const sortedReport = [...report].sort((a, b) => new Date(b.date) - new Date(a.date));
                              let lastDateLabel = null;

                              return sortedReport.flatMap((r, i) => {
                                const dateLabel = formatDateOnly(r.date);
                                const rows = [];

                                if (dateLabel !== lastDateLabel) {
                                  lastDateLabel = dateLabel;
                                  rows.push(
                                    <tr key={`date-${dateLabel}-${i}`} className="attendance-date-row">
                                      <td colSpan={5}>
                                        <div className="attendance-date-divider">{dateLabel}</div>
                                      </td>
                                    </tr>
                                  );
                                }

                                rows.push(
                                  <tr key={`record-${i}`}>
                                    <td className="attendance-record-date">{dateLabel}</td>
                                    <td>{r.first_name} {r.last_name}</td>
                                    <td>
                                      <span className={`attendance-status-pill attendance-status-pill--${String(r.status || '').toLowerCase()}`}>
                                        {r.status}{r.is_late ? ' · late' : ''}
                                      </span>
                                    </td>
                                    <td>{r.is_late ? 'Yes' : 'No'}</td>
                                    <td>{r.comment || '—'}</td>
                                  </tr>
                                );

                                return rows;
                              });
                            })()}
                          </tbody>
                        </Table>
                        <div className="attendance-mobile-log d-md-none">
                          {(() => {
                            const sortedReport = [...report].sort((a, b) => new Date(b.date) - new Date(a.date));
                            let lastDateLabel = null;

                            return sortedReport.flatMap((r, i) => {
                              const dateLabel = formatDateOnly(r.date);
                              const statusKey = String(r.status || '').toLowerCase();
                              const cards = [];

                              if (dateLabel !== lastDateLabel) {
                                lastDateLabel = dateLabel;
                                cards.push(
                                  <div key={`mobile-date-${dateLabel}-${i}`} className="attendance-mobile-date-divider">
                                    {dateLabel}
                                  </div>
                                );
                              }

                              cards.push(
                                <div key={`mobile-record-${i}`} className={`attendance-mobile-card attendance-mobile-card--${statusKey}`}>
                                  <div className="attendance-mobile-card__header">
                                    <div>
                                      <div className="attendance-mobile-card__name">{r.first_name} {r.last_name}</div>
                                    </div>
                                    <span className={`attendance-status-pill attendance-status-pill--${statusKey}`}>
                                      {r.status}{r.is_late ? ' · late' : ''}
                                    </span>
                                  </div>
                                  <div className="attendance-mobile-card__grid">
                                    <div>
                                      <div className="attendance-mobile-card__label">Late</div>
                                      <div className="attendance-mobile-card__value">{r.is_late ? 'Yes' : 'No'}</div>
                                    </div>
                                    <div>
                                      <div className="attendance-mobile-card__label">Comment</div>
                                      <div className="attendance-mobile-card__value">{r.comment || '—'}</div>
                                    </div>
                                  </div>
                                </div>
                              );

                              return cards;
                            });
                          })()}
                        </div>
                      </Card.Body>
                    </Card>
                  </>
                )}
              </Modal.Body>

            </Modal>
          </>
        )}

       {/* NOTES MODAL */}
<Modal dialogClassName="teacher-work-modal" show={showNotes} onHide={() => setShowNotes(false)} centered size="lg">
  <Modal.Header closeButton>
    <Modal.Title>
      {notesStudent ? `Student notes — ${notesStudent.first_name} ${notesStudent.last_name}` : 'Student notes'}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <p id="student-note-help" className="teacher-help-text">Notes are shared with teachers and admins in your markaz.</p>
    {/* Add new note */}
    <Form onSubmit={handleAddStudentNote} className="d-flex flex-wrap gap-2 mb-3">
      <Form.Control
        placeholder="Write a student note" aria-label="Student note" aria-describedby="student-note-help"
        value={newNoteText}
        onChange={(e) => setNewNoteText(e.target.value)}
        className="flex-grow-1"
      />
      <Button variant="success" type="submit">Add</Button>
    </Form>

    {/* Notes list */}
    {notesLoading ? (
      <div className="py-4 text-center">Loading…</div>
    ) : notes.length === 0 ? (
      <p className="text-muted mb-0">No notes yet.</p>
    ) : (
      <Table bordered responsive size="sm">
        <thead>
          <tr>
            <th style={{ width: '55%' }}>Note</th>
            <th>Teacher</th>
            <th>Created</th>
            <th style={{ width: 140 }} className="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          {notes.map((n) => (
            <tr key={n.id}>
              <td>
                {editingNoteId === n.id ? (
                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={editingNoteText}
                    onChange={(e) => setEditingNoteText(e.target.value)}
                  />
                ) : (
                  <div style={{ whiteSpace: 'pre-wrap' }}>{n.note_text}</div>
                )}
              </td>

              <td><small>{n.author_name || 'Unknown'}</small></td>
              <td><small>{fmtDateTime(n.created_at)}</small></td>

              <td className="text-end">
                {editingNoteId === n.id ? (
                  <>
                    <Button size="sm" variant="primary" onClick={handleSaveStudentNote}>
                      Save
                    </Button>{' '}
                    <Button size="sm" variant="secondary" onClick={cancelEditNote}>
                      Cancel
                    </Button>
                  </>
                ) : (
                  <Dropdown align="end">
                    <Dropdown.Toggle size="sm" variant="outline-secondary">
                      Actions
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => startEditNote(n)}>
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item
                        className="text-danger"
                        onClick={() => confirmDeleteStudentNote(n)}
                      >
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    )}
  </Modal.Body>
</Modal>


<Modal show={!!noteToDelete} onHide={() => setNoteToDelete(null)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Delete note?</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    Are you sure you want to delete this note?
    <div className="mt-2"><em>{noteToDelete?.text}</em></div>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setNoteToDelete(null)}>
      Cancel
    </Button>
    <Button variant="danger" onClick={handleDeleteStudentNote}>
      Delete
    </Button>
  </Modal.Footer>
</Modal>


{/* QURAN ASSIGNMENTS MODAL */}
<Modal
  dialogClassName="teacher-work-modal"
  show={showQuranAssignments}
  onHide={() => setShowQuranAssignments(false)}
  centered
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>
      {quranStudent
        ? `Quran assignments — ${quranStudent.first_name} ${quranStudent.last_name}`
        : 'Quran assignments'}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form onSubmit={handleAddQuranAssignment} className="quran-assignment-form">
      <div className="quran-assignment-form__heading">
        <div>
          <h3>Assign a passage</h3>
          <p>Select a surah and the verses the student should study.</p>
        </div>
        <i className="bi bi-book" aria-hidden="true" />
      </div>

      <Row className="g-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Surah</Form.Label>
            <Form.Select
              value={quranAssignmentForm.surah_number}
              onChange={(event) => handleQuranSurahChange(event.target.value)}
              required
            >
              <option value="">Select a surah</option>
              {quranChapters.map(chapter => (
                <option key={chapter.number} value={chapter.number}>
                  {chapter.number}. {chapter.name} ({chapter.verseCount} verses)
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={6} md={3}>
          <Form.Group>
            <Form.Label>From verse</Form.Label>
            <Form.Select
              value={quranAssignmentForm.start_verse}
              disabled={!selectedQuranChapter}
              onChange={(event) => {
                const startVerse = event.target.value;
                setQuranAssignmentForm(previous => ({
                  ...previous,
                  start_verse: startVerse,
                  end_verse: Number(previous.end_verse) < Number(startVerse) ? startVerse : previous.end_verse,
                }));
              }}
            >
              {Array.from({ length: selectedQuranChapter?.verseCount || 1 }, (_, index) => (
                <option key={index + 1} value={index + 1}>{index + 1}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={6} md={3}>
          <Form.Group>
            <Form.Label>To verse</Form.Label>
            <Form.Select
              value={quranAssignmentForm.end_verse}
              disabled={!selectedQuranChapter}
              onChange={(event) => setQuranAssignmentForm(previous => ({ ...previous, end_verse: event.target.value }))}
            >
              {Array.from({ length: selectedQuranChapter?.verseCount || 1 }, (_, index) => index + 1)
                .filter(verse => verse >= Number(quranAssignmentForm.start_verse || 1))
                .map(verse => <option key={verse} value={verse}>{verse}</option>)}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Due date <span className="text-muted">(optional)</span></Form.Label>
            <Form.Control
              type="date"
              value={quranAssignmentForm.due_date}
              onChange={(event) => setQuranAssignmentForm(previous => ({ ...previous, due_date: event.target.value }))}
            />
          </Form.Group>
        </Col>
        <Col md={8}>
          <Form.Group>
            <Form.Label>Instructions <span className="text-muted">(optional)</span></Form.Label>
            <Form.Control
              value={quranAssignmentForm.instructions}
              onChange={(event) => setQuranAssignmentForm(previous => ({ ...previous, instructions: event.target.value }))}
              placeholder="For example: memorize and review with tajweed"
              maxLength={1000}
            />
          </Form.Group>
        </Col>
      </Row>
      <div className="d-flex justify-content-end mt-3">
        <Button
          type="submit"
          variant="success"
          disabled={!selectedQuranChapter || quranAssignmentSaving}
        >
          {quranAssignmentSaving ? 'Assigning…' : 'Assign Quran'}
        </Button>
      </div>
    </Form>

    <div className="quran-assignment-list">
      <div className="quran-assignment-list__heading">
        <h3>Assignments</h3>
        <span>{quranAssignments.length}</span>
      </div>
      {quranAssignmentsLoading ? (
        <div className="teacher-panel-empty">Loading assignments…</div>
      ) : quranAssignments.length === 0 ? (
        <div className="teacher-panel-empty">
          <i className="bi bi-book" aria-hidden="true" />
          <strong>No Quran assignments yet</strong>
          <p>Use the form above to assign the first passage.</p>
        </div>
      ) : (
        <div className="quran-assignment-cards">
          {quranAssignments.map(assignment => (
            <article
              className={`quran-assignment-card${assignment.status === 'completed' ? ' quran-assignment-card--completed' : ''}`}
              key={assignment.id}
            >
              <div className="quran-assignment-card__content">
                {assignment.assignment_type === 'pages' ? (
                  <>
                    <div className="quran-assignment-card__surah">
                      <span>Madinah Mushaf</span>
                      <h4>Pages {assignment.start_page}–{assignment.end_page}</h4>
                    </div>
                    <div className="quran-assignment-card__range">
                      <strong>{Number(assignment.end_page) - Number(assignment.start_page) + 1}</strong>{' '}
                      {Number(assignment.end_page) === Number(assignment.start_page) ? 'page' : 'pages'}
                    </div>
                  </>
                ) : assignment.assignment_type === 'surah_pages' ? (
                  <>
                    <div className="quran-assignment-card__surah">
                      <span>Surah {assignment.surah_number}</span>
                      <h4>{assignment.surah_name}</h4>
                    </div>
                    <div className="quran-assignment-card__range">
                      Pages <strong>{assignment.start_page}–{assignment.end_page}</strong>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="quran-assignment-card__surah">
                      <span>Surah {assignment.surah_number}</span>
                      <h4>{assignment.surah_name}</h4>
                    </div>
                    <div className="quran-assignment-card__range">
                      Verses <strong>{assignment.start_verse}–{assignment.end_verse}</strong>
                    </div>
                  </>
                )}
                {assignment.instructions && <p>{assignment.instructions}</p>}
                <div className="quran-assignment-card__meta">
                  <span>{assignment.due_date ? `Due ${formatDateOnly(assignment.due_date)}` : 'No due date'}</span>
                  <span>Assigned by {assignment.teacher_name || 'Teacher'}</span>
                </div>
              </div>
              <div className="quran-assignment-card__actions">
                <span className={`quran-assignment-status quran-assignment-status--${assignment.status}`}>
                  {assignment.status === 'completed' ? 'Completed' : 'Assigned'}
                </span>
                <Button size="sm" variant={assignment.status === 'completed' ? 'outline-secondary' : 'success'} onClick={() => handleQuranAssignmentStatus(assignment)}>
                  {assignment.status === 'completed' ? 'Reopen' : 'Mark complete'}
                </Button>
                <Button size="sm" variant="outline-danger" onClick={() => handleDeleteQuranAssignment(assignment)}>
                  Delete
                </Button>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  </Modal.Body>
</Modal>


{/* GOALS MODAL */}
<Modal dialogClassName="teacher-work-modal" show={showGoals} onHide={() => setShowGoals(false)} centered size="lg" className="goals-modal">
  <Modal.Header closeButton>
    <Modal.Title>
      {goalsStudent ? `Goals — ${goalsStudent.first_name} ${goalsStudent.last_name}` : 'Goals'}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {/* Add new goal */}
    <Form onSubmit={handleAddStudentGoal} className="d-flex flex-column gap-2 mb-3">
      <Form.Control
        placeholder="Add a goal (e.g., memorize Surah Al-Baqarah)"
        value={newGoalText}
        onChange={(e) => setNewGoalText(e.target.value)}
      />

      <Row className="g-2">
        <Col md={4} xs={12}>
          <Form.Select
            value={newGoalTerm}
            onChange={(e) => setNewGoalTerm(e.target.value)}
          >
            <option value="">Select Term</option>
            <option value="Weekend">Weekend</option>
            <option value="After-school">After-school</option>
            <option value="Summer-dugsi">Summer-dugsi</option>
          </Form.Select>
        </Col>

        <Col md={4} xs={12}>
          <Form.Select
            value={newGoalStatus}
            onChange={(e) => setNewGoalStatus(e.target.value)}
          >
            <option value="in-progress">In Progress</option>
            <option value="completed">Completed</option>
            <option value="incomplete">Incomplete</option>
          </Form.Select>
        </Col>

        <Col md={4} xs={12}>
          <Form.Control
            type="date"
            value={newGoalDueDate || ''}
            onChange={(e) => setNewGoalDueDate(e.target.value)}
          />
        </Col>
      </Row>

      <Button variant="success" type="submit" className="mt-2">Add Goal</Button>
    </Form>

    {/* Goals list */}
    {goalsLoading ? (
      <div className="py-4 text-center">Loading…</div>
    ) : goals.length === 0 ? (
      <p className="text-muted mb-0">No goals yet.</p>
    ) : (
      <>
        {/* Desktop/Tablet: table */}
        <div className="d-none d-md-block">
          <Table bordered responsive size="sm">
            <thead>
              <tr>
                <th style={{ width: '35%' }}>Goal</th>
                <th>Term</th>
                <th>Status</th>
                <th>Due Date</th>
                <th>Teacher</th>
                <th>Created</th>
                <th style={{ width: 140 }} className="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {goals.map((g) => (
                <tr key={g.id}>
                  {/* GOAL TEXT */}
                  <td>
                    {editingGoalId === g.id ? (
                      <Form.Control
                        as="textarea"
                        rows={2}
                        value={editingGoalText}
                        onChange={(e) => setEditingGoalText(e.target.value)}
                      />
                    ) : (
                      <div style={{ whiteSpace: 'pre-wrap' }}>{g.goal_text}</div>
                    )}
                  </td>

                  {/* TERM */}
                  <td style={{ minWidth: 140 }}>
                    {editingGoalId === g.id ? (
                      <Form.Select
                        value={editingGoalTerm}
                        onChange={(e) => setEditingGoalTerm(e.target.value)}
                      >
                        <option value="">Select Term</option>
                        <option value="Weekend">Weekend</option>
                        <option value="After-school">After-school</option>
                        <option value="Summer-dugsi">Summer-dugsi</option>
                      </Form.Select>
                    ) : (
                      g.term || '—'
                    )}
                  </td>

                  {/* STATUS */}
                  <td style={{ minWidth: 160 }}>
                    {editingGoalId === g.id ? (
                      <Form.Select
                        value={editingGoalStatus}
                        onChange={(e) => setEditingGoalStatus(e.target.value)}
                      >
                        <option value="in-progress">In Progress</option>
                        <option value="completed">Completed</option>
                        <option value="incomplete">Incomplete</option>
                      </Form.Select>
                    ) : (
                      <span
                        className={
                          g.status === 'completed'
                            ? 'text-success fw-semibold'
                            : g.status === 'incomplete'
                            ? 'text-danger fw-semibold'
                            : 'text-warning fw-semibold'
                        }
                      >
                        {g.status?.replace('-', ' ') || '—'}
                      </span>
                    )}
                  </td>

                  {/* DUE DATE */}
                  <td style={{ minWidth: 140 }}>
                    {editingGoalId === g.id ? (
                      <Form.Control
                        type="date"
                        value={editingGoalDueDate || ''}
                        onChange={(e) => setEditingGoalDueDate(e.target.value)}
                      />
                    ) : (
                      g.due_date ? new Date(g.due_date).toLocaleDateString() : '—'
                    )}
                  </td>

                  {/* TEACHER + CREATED */}
                  <td><small>{g.author_name || 'Unknown'}</small></td>
                  <td><small>{fmtDateTime(g.created_at)}</small></td>

                  {/* ACTIONS */}
                  <td className="text-end">
                    {editingGoalId === g.id ? (
                      <>
                        <Button size="sm" variant="primary" onClick={handleSaveStudentGoal}>
                          Save
                        </Button>{' '}
                        <Button size="sm" variant="secondary" onClick={cancelEditGoal}>
                          Cancel
                        </Button>
                      </>
                    ) : (
                      <Dropdown align="end">
                        <Dropdown.Toggle size="sm" variant="outline-secondary">
                          Actions
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          renderOnMount
                          popperConfig={{ strategy: 'fixed' }}
                          style={{ zIndex: 2000 }}
                        >
                          <Dropdown.Item onClick={() => startEditGoal(g)}>
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Divider />
                          <Dropdown.Item
                            className="text-danger"
                            onClick={() => confirmDeleteStudentGoal(g)}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {/* Mobile: cards */}
        <div className="d-block d-md-none">
          <Row xs={1} className="g-3">
            {goals.map((g) => (
              <Col key={g.id}>
                <Card className="shadow-sm">
                  <Card.Body className="p-3">
                    {/* GOAL */}
                    <div className="mb-2">
                      <div className="small text-muted">Goal</div>
                      {editingGoalId === g.id ? (
                        <Form.Control
                          as="textarea"
                          rows={2}
                          value={editingGoalText}
                          onChange={(e) => setEditingGoalText(e.target.value)}
                        />
                      ) : (
                        <div style={{ whiteSpace: 'pre-wrap' }}>{g.goal_text}</div>
                      )}
                    </div>

                    {/* TERM & STATUS */}
                    <Row className="g-2">
                      <Col xs={6}>
                        <div className="small text-muted mb-1">Term</div>
                        {editingGoalId === g.id ? (
                          <Form.Select
                            value={editingGoalTerm}
                            onChange={(e) => setEditingGoalTerm(e.target.value)}
                          >
                            <option value="">Select Term</option>
                            <option value="Weekend">Weekend</option>
                            <option value="After-school">After-school</option>
                            <option value="Summer-dugsi">Summer-dugsi</option>
                          </Form.Select>
                        ) : (
                          <div>{g.term || '—'}</div>
                        )}
                      </Col>
                      <Col xs={6}>
                        <div className="small text-muted mb-1">Status</div>
                        {editingGoalId === g.id ? (
                          <Form.Select
                            value={editingGoalStatus}
                            onChange={(e) => setEditingGoalStatus(e.target.value)}
                          >
                            <option value="in-progress">In Progress</option>
                            <option value="completed">Completed</option>
                            <option value="incomplete">Incomplete</option>
                          </Form.Select>
                        ) : (
                          <div
                            className={
                              g.status === 'completed'
                                ? 'text-success fw-semibold'
                                : g.status === 'incomplete'
                                ? 'text-danger fw-semibold'
                                : 'text-warning fw-semibold'
                            }
                          >
                            {g.status?.replace('-', ' ') || '—'}
                          </div>
                        )}
                      </Col>
                    </Row>

                    {/* DUE DATE */}
                    <div className="mt-2">
                      <div className="small text-muted mb-1">Due Date</div>
                      {editingGoalId === g.id ? (
                        <Form.Control
                          type="date"
                          value={editingGoalDueDate || ''}
                          onChange={(e) => setEditingGoalDueDate(e.target.value)}
                        />
                      ) : (
                        <div>{g.due_date ? new Date(g.due_date).toLocaleDateString() : '—'}</div>
                      )}
                    </div>

                    {/* TEACHER & CREATED */}
                    <Row className="g-2 mt-2">
                      <Col xs={6}>
                        <div className="small text-muted mb-1">Teacher</div>
                        <div className="small">{g.author_name || 'Unknown'}</div>
                      </Col>
                      <Col xs={6}>
                        <div className="small text-muted mb-1">Created</div>
                        <div className="small">{fmtDateTime(g.created_at)}</div>
                      </Col>
                    </Row>

                    {/* ACTIONS */}
                    <div className="d-flex justify-content-end mt-3">
                      {editingGoalId === g.id ? (
                        <>
                          <Button size="sm" variant="primary" onClick={handleSaveStudentGoal}>
                            Save
                          </Button>
                          <Button
                            size="sm"
                            variant="secondary"
                            className="ms-2"
                            onClick={cancelEditGoal}
                          >
                            Cancel
                          </Button>
                        </>
                      ) : (
                      <Dropdown align="end" drop="up" className="actions-dropdown">
                        <Dropdown.Toggle size="sm" variant="outline-secondary">
                          Actions
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          renderOnMount
                          popperConfig={{
                            strategy: 'fixed',
                            modifiers: [
                              { name: 'preventOverflow', options: { boundary: 'viewport' } },
                              { name: 'flip', options: { fallbackPlacements: ['top', 'left'] } },
                            ],
                          }}
                        >
                          <Dropdown.Item onClick={() => startEditGoal(g)}>Edit</Dropdown.Item>
                          <Dropdown.Divider />
                          <Dropdown.Item className="text-danger" onClick={() => confirmDeleteStudentGoal(g)}>
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>

                      )}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </>
    )}
  </Modal.Body>
</Modal>


<Modal
  show={Boolean(attendanceProfileStudent)}
  onHide={() => setAttendanceProfileStudent(null)}
  centered
  size="lg"
  fullscreen="sm-down"
  dialogClassName="teacher-student-profile-modal"
>
  <Modal.Header closeButton>
    <Modal.Title>Student profile</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {attendanceProfileStudent && (
      <>
        <div className="teacher-student-profile-hero">
          <div className="teacher-student-profile-avatar" aria-hidden="true">
            {`${attendanceProfileStudent.first_name?.[0] || ''}${attendanceProfileStudent.last_name?.[0] || ''}`.toUpperCase()}
          </div>
          <div>
            <span>Student</span>
            <h2>{attendanceProfileStudent.first_name} {attendanceProfileStudent.last_name}</h2>
            <p><i className="bi bi-easel me-1" aria-hidden="true" />{attendanceProfileStudent.class_name || 'Class not assigned'}</p>
          </div>
        </div>
        <div className="teacher-student-profile-attendance">
          <StudentAttendancePanel studentId={attendanceProfileStudent.id} />
        </div>
      </>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setAttendanceProfileStudent(null)}>Close</Button>
  </Modal.Footer>
</Modal>

<Modal show={showTeacherStudentModal} onHide={() => setShowTeacherStudentModal(false)} centered>
  <Form onSubmit={handleSaveTeacherStudent}>
    <Modal.Header closeButton>
      <Modal.Title>{editingTeacherStudent ? 'Edit Student' : 'Add Student'}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row className="g-3">
        <Col md={6}>
          <Form.Label>First Name</Form.Label>
          <Form.Control
            value={teacherStudentForm.first_name}
            onChange={(e) => setTeacherStudentForm((prev) => ({ ...prev, first_name: e.target.value }))}
            autoFocus
            required
          />
        </Col>
        <Col md={6}>
          <Form.Label>Last Name</Form.Label>
          <Form.Control
            value={teacherStudentForm.last_name}
            onChange={(e) => setTeacherStudentForm((prev) => ({ ...prev, last_name: e.target.value }))}
            required
          />
        </Col>
      </Row>
      {!editingTeacherStudent && (
        <div className="small text-muted mt-3">
          The student will be added to the selected class using that class shift.
        </div>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={() => setShowTeacherStudentModal(false)}>
        Cancel
      </Button>
      <Button variant="success" type="submit">
        {editingTeacherStudent ? 'Save Student' : 'Add Student'}
      </Button>
    </Modal.Footer>
  </Form>
</Modal>


<Modal show={!!studentToRemove} onHide={() => setStudentToRemove(null)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Remove from class?</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <p className="mb-2">
      Remove <strong>{studentToRemove?.first_name} {studentToRemove?.last_name}</strong> from this class?
    </p>
    <div className="text-muted small">
      The student, parent links, and attendance history will stay saved. An admin can reassign the student later.
    </div>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setStudentToRemove(null)}>
      Cancel
    </Button>
    <Button variant="danger" onClick={handleRemoveTeacherStudentFromClass}>
      Remove from Class
    </Button>
  </Modal.Footer>
</Modal>


<Modal show={!!goalToDelete} onHide={() => setGoalToDelete(null)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Delete goal?</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    Are you sure you want to delete this goal?
    <div className="mt-2"><em>{goalToDelete?.text}</em></div>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setGoalToDelete(null)}>
      Cancel
    </Button>
    <Button variant="danger" onClick={handleDeleteStudentGoal}>
      Delete
    </Button>
  </Modal.Footer>
</Modal>


      </Container>
    </div>
  );
};

export default TeacherDashboard;
